import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">焦点速递</h2>
          <p className="text-foreground-600 text-sm md:text-base">全网最热话题，一网打尽</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item, idx) => (
            <article
              key={item.id}
              className={`group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer ${
                idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'h-52 lg:h-72' : 'h-44'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={idx > 2 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className={`text-white font-semibold leading-snug ${idx === 0 ? 'text-lg md:text-xl' : 'text-sm md:text-base'}`}>
                    {item.title}
                  </h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed mb-3 line-clamp-2">
                  {item.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500"></i>
                    {item.heat}
                  </span>
                  <span>{item.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}